import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=542d855a&scoped=true"
import script from "./EpsCard.js?vue&type=script&lang=js&external"
export * from "./EpsCard.js?vue&type=script&lang=js&external"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=542d855a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d855a",
  null
  
)

export default component.exports